export default {
    INPUT: 'input',
    SELECT: 'select',
    TEXTAREA: 'textarea'
};
